import { AxiosInstance, AxiosRequestConfig } from 'axios'

import { PaymentConfigRepository } from './domain'

import { PaymentConfig } from '../../contracts/payment'
import { AxiosErrorHandler } from '../../foundation'

export class AdminApiPaymentConfig implements PaymentConfigRepository {
  private errorHandler: AxiosErrorHandler

  constructor(private axios: AxiosInstance) {
    this.errorHandler = new AxiosErrorHandler()
  }

  getHospitalPaymentConfig = async (hospitalId: number): Promise<PaymentConfig> => {
    const config: AxiosRequestConfig<{ id: number }> = {
      url: `/admin/payment/hospital-payment-configurations/${hospitalId}`,
      method: 'get',
    }
    try {
      const { data } = await this.axios.request<PaymentConfig>(config)
      return data
    } catch (error) {
      return this.errorHandler.handle(error)
    }
  }
}
